
import { Vue, Options, prop } from "vue-class-component";

class Props {
  isHangingIncoming = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: [
    "filter"
  ]
})
class Filter extends Vue.with(Props) {
  filter = {
    search: "",
    days: [] as string[],
    existenceStatus: { name: "", value: "" },
    statusFollowUp: { name: "", value: "" },
  };
  get filterDay() {
    return [
      { name: this.$t("dashboard.filterHistoryHanging.day3"), value: "3" },
      { name: this.$t("dashboard.filterHistoryHanging.day4"), value: "4" },
      { name: this.$t("dashboard.filterHistoryHanging.day5"), value: "5" },
      { name: this.$t("dashboard.filterHistoryHanging.day6"), value: "6" },
      { name: this.$t("dashboard.filterHistoryHanging.day7Plus"), value: ">=7" },
    ];
  }
  activeIndexes: string[] = [];
  toggleActive = (value: string) => {
    if (this.activeIndexes.includes(value)) {
      this.activeIndexes = this.activeIndexes.filter((i) => i !== value);
    } else {
      this.activeIndexes.push(value);
      this.filter.days = [...this.activeIndexes];
    }
    this.$emit("filter", { search: this.filter.search, days: this.activeIndexes, existenceStatus: this.filter.existenceStatus.value, statusFollowUp: this.filter.statusFollowUp.value });
  };
  statusSelect = false;
  onOpenStatus(value: boolean) {
    this.statusSelect = value;
  }
  onSelectStatus(value: any) {
    if (this.filter.existenceStatus.name === value.name) {
      this.filter.existenceStatus = { name: "", value: "" };
    } else {
      this.filter.existenceStatus = value;
    }
    this.$emit("filter", {
      search: this.filter.search,
      days: this.activeIndexes,
      existenceStatus: this.filter.existenceStatus.value,
      statusFollowUp: this.filter.statusFollowUp.value,
    });
  }


  statusSelectFollow = false;

  onSelectStatusFollow(value: any) {
    if (this.filter.statusFollowUp.name === value.name) {
      this.filter.statusFollowUp = { name: "", value: "" };
    } else {
      this.filter.statusFollowUp = value;
    }
    this.$emit("filter", { search: this.filter.search, days: this.activeIndexes, existenceStatus: this.filter.existenceStatus.value, statusFollowUp: this.filter.statusFollowUp.value });
  }

  get statusData() {
    return [
      { name: this.$t("dashboard.hanging.all"), value: "" },
      { name: this.$t("dashboard.hanging.statusNotFound"), value: "belum_ditemukan" },
      { name: this.$t("dashboard.hanging.statusFoundConsole"), value: "ditemukan_konsol" },
      { name: this.$t("dashboard.hanging.statusFoundPos"), value: "ditemukan_pos" },
    ];
  }

  get statusFollowUp() {
    return [
      { name: this.$t("dashboard.hanging.all"), value: "" },
      { name: this.isHangingIncoming ? this.$t("dashboard.hanging.notCompleted") : this.$t("dashboard.hanging.notFollowedUp"), value: "belum" },
      { name: this.isHangingIncoming ? this.$t("dashboard.hanging.completed") : this.$t("dashboard.hanging.followedUp"), value: "sudah" },
    ];
  }

  onSearch(value: string) {
    this.filter.search = value;
    this.$emit("filter", { search: this.filter.search, days: this.activeIndexes, existenceStatus: this.filter.existenceStatus.value, statusFollowUp: this.filter.statusFollowUp.value });
  }

  clearSearch() {
    this.filter.search = "";
    this.$emit("filter", { search: this.filter.search, days: this.activeIndexes, existenceStatus: this.filter.existenceStatus.value, statusFollowUp: this.filter.statusFollowUp.value });
  }
}
export default Filter;
